import React, { useEffect, useState } from 'react';
import Styles from '../style/homeChallenge.module.scss';
import MaleAvatar from "../../../../assets/theme6/bigMan.png";
import WaitAvatarCard from "../../../../assets/theme6/waitingAvatar.png";
import Profile from '../../../../assets/theme6/profile_icon.svg';
import Fav from '../../../../assets/theme6/fav.svg';
import { Link, useNavigate } from 'react-router-dom';
import Heart from '../../../../assets/theme6/heart.svg';
import RedeemCard from '../../../../comman/card/RedeemCard';
import ChallengeType from '../../../../comman/card/ChallengeType';
import Wallet from '../../../../assets/svg/Wallet';
import BottomBar from '../component/BottomBar';
import authAxios from '../../../../config/authAxios';
import QuizWallicon from '../../../../assets/svg/QuizWallicon';
const HomeChallenge = () => {
	    window.scrollTo(0, 0);

	const navigation = useNavigate()
	  const theme = localStorage.getItem('pwa_app_theme')

	const [data, setData] = useState({})
	const [isReward, setIsReward] = useState({})
	const fetchRewardInfo = async (e) => {
		try {
			const response = await authAxios.get(`/users/api/giftMission`);
			setData(response?.data?.data)
			setIsReward(response?.data?.isReward)
		} catch (error) {
			console.error(error);
		}
	}
	useEffect(() => {
		if(JSON.parse(theme) != 6){
			navigation("/home")
			return
		}
		fetchRewardInfo()
	}, [])


	return (
		<>
			<div className={Styles.parent}>
				<div className={Styles.quizIcon}>
					<QuizWallicon width={150} height={32} />
				</div>
				<div className={Styles.menu}>
					<div className={Styles.profile__div}>
						<Link to={'/profile'} className={Styles.profile_img}>
							<img className={Styles.profile} width={"100%"} src={Profile} />
						</Link>
						<p>Profile</p>
					</div>
					<div className={Styles.profile__div}>
						<Link to={'/favorite-mission-reward'} className={Styles.profile_img}>
							<img className={Styles.profile} width={"100%"} src={Fav} />
						</Link>
						<p>Favourite</p>
					</div>
					<div className={Styles.profile__div}>
						<Link to={'/wallet'} className={Styles.profile_img}>
							<Wallet />
						</Link>
						<p>Wallet</p>
					</div>
				</div>
				<div className={Styles.avatarCover}>
					<div className={Styles.avatarBox}>
						<img width={"100%"} src={MaleAvatar} className={Styles.avatarImg}  />
					</div>
					<div className={Styles.boxAvatarCover}>
						<div className={Styles.boxAvatarBox}>
							<div className={Styles.boxCardText}>
								<h2 className={Styles.text1}>Daily</h2>
								<h3 className={Styles.text2}>challenges</h3>
								<p className={Styles.text3} >Get 3x Rewards</p>

							</div>
							<span className={Styles.boxQues1}>?</span>
							<span className={Styles.boxQues2}>?</span>
							<span className={Styles.boxQues3}>?</span>
							<div className={Styles.waitBox}>
								<img width={"100%"} src={WaitAvatarCard}  />
							</div>
							<div className={Styles.boxBtn} onClick={() => navigation('/daily-challenge')} >
								<svg xmlns="http://www.w3.org/2000/svg" width="14" height="20" viewBox="0 0 14 20" fill="none">
									<path d="M12.3687 5.83832L4.47392 1.60303M10.7897 10.7795L1.63181 10.7795M12.3687 15.3677L7.00023 18.8971" stroke="#fff" stroke-width="2.11765" stroke-linecap="round" />
								</svg>
								<p>PLAY NOW</p>
								<svg xmlns="http://www.w3.org/2000/svg" width="14" height="20" viewBox="0 0 14 20" fill="none">
									<path d="M1.31592 5.83832L9.21065 1.60303M2.89487 10.7795L12.0528 10.7795M1.31592 15.3677L6.68434 18.8971" stroke="#fff" stroke-width="2.11765" stroke-linecap="round" />
								</svg>
							</div>
						</div>
					</div>
				</div>


				<div className={Styles.radiusCover}>


					{/* {isReward &&  data?.totalPrice > 0 && <div className={Styles.redeem_div}>
						<RedeemCard data1={data} />
					</div>} */}

					<div className={Styles.challenge_type} style={{marginTop : "20px"}}>
						<ChallengeType onClick={() => navigation('/mission-reward')} line1='Rewarding' line2='Missions' line3='Fun and Engaging Mission' backgroundColor='#FFEAEE' txtColor='#E12D4B' btnText='Play Now' btnBg='#FA5743' btnFill='#FFFFFF' />
					</div>
					<div className={Styles.challenge_type} >
						<ChallengeType onClick={() => {}} line1='Weekly' line2='Tournaments' line3='Earn 300 coins daily' backgroundColor='#EFFFF5' txtColor='#08A742' btnText='Coming Soon' btnBg='#FFFFFF' btnFill='#FA5743' />
					</div>


					<div className={Styles.bottom_text}>Pick, <br /> Play & <span className={Styles.color_text}>Earn!</span></div>
					<div id="bottomDiv" className={Styles.jingle_text}>Made with <img style={{ position: 'relative', top: "5px" }} src={Heart} /></div>
				</div>
				<BottomBar />
			</div>


		</>
	)
}

export default HomeChallenge;